import { gql } from '@apollo/client'

export const PMS_TRIGGER_MUTATION = gql`
  mutation PMSTrigger($propertyCode: String!, $providerCode: String!) {
    PMSTrigger(propertyCode: $propertyCode, providerCode: $providerCode) {
      message
    }
  }
`
